import { getOr } from 'lodash/fp';

const getOrNull = getOr(null, 'referral.url');
const selectReferralUrl = getOrNull;

export default selectReferralUrl;
